<template>
    <v-app :style="'background-image: url(' + require('@/images/background.jpg') + '); background-size: cover; background-position: center; background-repeat: no-repeat;'" >
        <v-main>
            <slot />
        </v-main>
    </v-app>
</template>

<script lang="ts">
    import Vue from "vue";
    import Component from "vue-class-component";

    @Component({})
    export default class BlankLayout extends Vue { }
</script>